import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filename'
})
export class FilenamePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let spliced = value.split('.');
    spliced.pop();
    return spliced.join('.');
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/filename/filename.pipe.ts